interface ColorFieldProps {
  label?: string;
  value: string;
  onChange: (hex: string) => void;
  /** "row" = label + small swatch; "block" = full-width bar. */
  variant?: "row" | "block";
}

export function ColorField({ label, value, onChange, variant = "row" }: ColorFieldProps) {
  if (variant === "block") {
    return (
      <input
        type="color"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="h-9 w-full cursor-pointer rounded-lg border border-outline-variant/60 bg-surface-container-lowest p-1"
      />
    );
  }
  return (
    <div className="flex items-center justify-between gap-2">
      {label ? <span className="font-body text-[11px] text-on-surface-variant">{label}</span> : null}
      <input
        type="color"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="h-6 w-9 cursor-pointer rounded-md border border-outline-variant/60 bg-surface-container-lowest p-0.5"
      />
    </div>
  );
}
